module.exports = {"Die Penetrant Testing":"Die Penetrant Testing","Magnetic Particle Testing":"Magnetic Particle Testing"}


//////////////////
// WEBPACK FOOTER
// ./src/config/nonDestructiveTesting.json
// module id = 5414
// module chunks = 1